import React from "react";
import { Typography } from "@mui/material";
import { DroneIcon, NoDroneIcon } from "../../../../Reuse/Icon";
import CustomTooltip from "../../../../Reuse/UI/CustomTooltip";
import StyleStack from "../../../../Reuse/UI/StyleStack";
import { useDroneUIState } from "./hooks/useDroneUIState";

const DroneUI = React.memo((props) => {
  const {
    value = 0,
    status = "Available",
    clickBox = null,
    boxValue = null,
    showEmpty = false,
    tooltip = "",
  } = props;

  const {
    isDroneAvailable,
    isDroneUnavailable,
    color,
    borderColor,
    background,
    cursor,
  } = useDroneUIState({ status, clickBox, boxValue });

  const shouldRender = value > 0 || showEmpty;

  if (!shouldRender) return null;

  const handleClick = (e) => {
    e.preventDefault();
    if (clickBox) {
      clickBox(status);
    }
  };

  const renderIcon = () => {
    if (isDroneUnavailable) {
      return <NoDroneIcon sx={{ color, fontSize: 16 }} />;
    }
    return <DroneIcon sx={{ color, fontSize: 16 }} />;
  };

  return (
    <CustomTooltip title={tooltip} placement="top">
      <StyleStack
        direction="row"
        sx={{
          border: "1px solid",
          borderColor,
          padding: 0.5,
          paddingRight: 1.25,
          gap: 0.5,
          alignItems: "center",
          cursor,
          background,
        }}
        onClick={handleClick}
      >
        {renderIcon()}
        <Typography variant="subtitle2" sx={{ color }}>
          {value}
        </Typography>
      </StyleStack>
    </CustomTooltip>
  );
});

export default DroneUI;